(function($) {
    $('#toggle').click(function() {
        $(this).toggleClass('active');
        $('#overlay').toggleClass('open');
    });

    // Lightbox Gallery

    $(document).on('click', '[data-toggle="lightbox"]', function(event) {
        event.preventDefault();
        $(this).ekkoLightbox({
            alwaysShowClose: true
        });
    });

    //Aos Animation

    AOS.init({
        offset: 200,
        duration: 800,
        disable: 'mobile',
        easing: 'ease-in-quad',
        delay: 100,
    });

    // Hamburger Toggle

    $(document).ready(function() {
        $('.first-button').on('click', function() {

            $('.animated-icon1').toggleClass('open');
        });

    });

    // DropDown Menu
    $('.dropdown').on('show.bs.dropdown', function(e) {
        $(this).find('.dropdown-menu').first().stop(true, true).slideDown(300);
    });

    $('.dropdown').on('hide.bs.dropdown', function(e) {
        $(this).find('.dropdown-menu').first().stop(true, true).slideUp(300);
    });


    // on Scroll logo resize
    /*  Header onscroll background-color */
    //$(function() {
    $(window).on("scroll", function() {
        if ($(window).scrollTop() > 50) {
            $(".navbar").addClass("fixed-top-zero");
            $(".navbar-brand-img").addClass("logo-resize");
        } else {
            //remove the background property so it comes transparent again (defined in your css)
            $(".navbar").removeClass("fixed-top-zero");
            $(".navbar-brand-img").removeClass("logo-resize");
        }
    });
    //});
})(jQuery);

